import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'

export default function AlertDialog({ open, title, message, noLabel, yesLabel, handleYes, handleNo }) {
    return (
        <Dialog open={!!open} onClose={handleNo} ria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle disableTypography style={{ paddingTop: 0 }}>
                <Typography variant={'h4'} style={{ paddingTop: 0 }}>
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                {noLabel && (
                    <Button onClick={handleNo} color="primary">
                        {noLabel ? noLabel : 'No'}
                    </Button>
                )}
                <Button onClick={handleYes} color="primary" autoFocus style={{ paddingRight: 16 }}>
                    {yesLabel ? yesLabel : 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
